var datafile = require("./data/provinces");

var formatInput = function formatInput(name) {
  return name ? name.charAt(0).toUpperCase() + name.substring(1) : undefined;
};

exports.Provinces = function () {
  return Object.keys(datafile);
};

exports.Districts = function () {
  var districts = [];

  for (var _i = 0, _Object$keys = Object.keys(datafile); _i < _Object$keys.length; _i++) {
    var province = _Object$keys[_i];

    for (var _i2 = 0, _Object$keys2 = Object.keys(datafile[province]); _i2 < _Object$keys2.length; _i2++) {
      var district = _Object$keys2[_i2];
      districts.push(district);
    }
  }

  return districts;
};

exports.District = function (province) {
  if (Object.keys(datafile).includes(formatInput(province))) {
    return Object.keys(datafile[formatInput(province)]);
  }

  return undefined;
};

exports.Sectors = function () {
  var sectors = [];

  for (var _i3 = 0, _Object$keys3 = Object.keys(datafile); _i3 < _Object$keys3.length; _i3++) {
    var province = _Object$keys3[_i3];

    for (var _i4 = 0, _Object$keys4 = Object.keys(datafile[province]); _i4 < _Object$keys4.length; _i4++) {
      var district = _Object$keys4[_i4];

      for (var _i5 = 0, _Object$keys5 = Object.keys(datafile[province][district]); _i5 < _Object$keys5.length; _i5++) {
        var sector = _Object$keys5[_i5];
        sectors.push(sector);
      }
    }
  }

  return sectors;
};

exports.Sector = function (province, district) {
  if (Object.keys(datafile).includes(formatInput(province)) && Object.keys(datafile[province]).includes(formatInput(district))) {
    return Object.keys(datafile[formatInput(province)][formatInput(district)]);
  }

  return undefined;
};

exports.Cells = function () {
  var cells = [];

  for (var _i6 = 0, _Object$keys6 = Object.keys(datafile); _i6 < _Object$keys6.length; _i6++) {
    var province = _Object$keys6[_i6];

    for (var _i7 = 0, _Object$keys7 = Object.keys(datafile[province]); _i7 < _Object$keys7.length; _i7++) {
      var district = _Object$keys7[_i7];

      for (var _i8 = 0, _Object$keys8 = Object.keys(datafile[province][district]); _i8 < _Object$keys8.length; _i8++) {
        var sector = _Object$keys8[_i8];

        for (var _i9 = 0, _Object$keys9 = Object.keys(datafile[province][district][sector]); _i9 < _Object$keys9.length; _i9++) {
          var cell = _Object$keys9[_i9];
          cells.push(cell);
        }
      }
    }
  }

  return cells;
};

exports.Cell = function (province, district, sector) {
  if (Object.keys(datafile).includes(formatInput(province)) && Object.keys(datafile[formatInput(province)]).includes(formatInput(district)) && Object.keys(datafile[formatInput(province)][formatInput(district)]).includes(formatInput(sector))) {
    return Object.keys(datafile[formatInput(province)][formatInput(district)][formatInput(sector)]);
  }

  return undefined;
};

exports.Villages = function () {
  var villages = [];

  for (var _i10 = 0, _Object$keys10 = Object.keys(datafile); _i10 < _Object$keys10.length; _i10++) {
    var province = _Object$keys10[_i10];

    for (var _i11 = 0, _Object$keys11 = Object.keys(datafile[province]); _i11 < _Object$keys11.length; _i11++) {
      var district = _Object$keys11[_i11];

      for (var _i12 = 0, _Object$keys12 = Object.keys(datafile[province][district]); _i12 < _Object$keys12.length; _i12++) {
        var sector = _Object$keys12[_i12];

        for (var _i13 = 0, _Object$keys13 = Object.keys(datafile[province][district][sector]); _i13 < _Object$keys13.length; _i13++) {
          var cell = _Object$keys13[_i13];

          for (var _i14 = 0, _Object$keys14 = Object.keys(datafile[province][district][sector][cell]); _i14 < _Object$keys14.length; _i14++) {
            var village = _Object$keys14[_i14];
            villages.push(datafile[province][district][sector][cell][village]);
          }
        }
      }
    }
  }

  return villages;
};

exports.Village = function (province, district, sector, cell) {
  if (Object.keys(datafile).includes(formatInput(province)) && Object.keys(datafile[formatInput(province)]).includes(formatInput(district)) && Object.keys(datafile[formatInput(province)][formatInput(district)]).includes(formatInput(sector)) && Object.keys(datafile[formatInput(province)][formatInput(district)][formatInput(sector)]).includes(formatInput(cell))) {
    return datafile[formatInput(province)][formatInput(district)][formatInput(sector)][formatInput(cell)];
  }

  return undefined;
};